export const itemConstants = {
    SET_PARAMS_REQUEST: 'ITEMS_SET_PARAMS_REQUEST',

    GETALL_REQUEST: 'ITEMS_GETALL_REQUEST',
    GETALL_SUCCESS: 'ITEMS_GETALL_SUCCESS',
    GETALL_FAILURE: 'ITEMS_GETALL_FAILURE',

    DELETE_REQUEST: 'ITEMS_DELETE_REQUEST',
    DELETE_SUCCESS: 'ITEMS_DELETE_SUCCESS',
    DELETE_FAILURE: 'ITEMS_DELETE_FAILURE',

    GET_REQUEST: 'ITEMS_GET_REQUEST',
    GET_SUCCESS: 'ITEMS_GET_SUCCESS',
    GET_FAILURE: 'ITEMS_GET_FAILURE',

    ADD_REQUEST: 'ITEMS_ADD_REQUEST',
    ADD_SUCCESS: 'ITEMS_ADD_SUCCESS',
    ADD_FAILURE: 'ITEMS_ADD_FAILURE',

    UPDATE_REQUEST: 'ITEMS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'ITEMS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'ITEMS_UPDATE_FAILURE',

    UPDATE_FIELD_REQUEST: 'ITEMS_UPDATE_FIELD_REQUEST',
    UPDATE_FIELD_SUCCESS: 'ITEMS_UPDATE_FIELD_SUCCESS',
    UPDATE_FIELD_FAILURE: 'ITEMS_UPDATE_FIELD_FAILURE',
}